angular.module('gantt.overlap.templates', []).run(['$templateCache', function($templateCache) {

}]);
